import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { TableExt, TableInfo, GridBox, themes } from 'libs/ui';
import { getTableParams } from './grid.params';
import { path } from 'router/sections';

export const TariffGrid = (props) => {
  const { disableClick, count, count_limit, count_method, getFilter, entries, className, theme, getXlsAction, clientId, categories, vehicleClasses } = props;

  const { t } = useTranslation();
  const history = useHistory();

  const rightView = user.haveRight('tariff.view');

  /**
   * go to tariff
   * @param {*} row
   * @returns
   */
  const onRowClick = (row) => {
    if (disableClick === true) {
      return;
    }
    history.push(path('tariff') + '?id=' + row.id);
  };

  /**
   * go to new tariff card
   */
  const gotoNewTariff = () => {
    history.push(path('new_tariff'));
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // top actions
  const topActions = [];
  topActions.push({ title: t('buttons.Добавить'), icon: 'fa-plus', action: gotoNewTariff, theme: themes.blue });
  if (count) {
    getXlsAction(topActions);
  }
  const tableParams = useMemo(() => getTableParams(false, t, categories, vehicleClasses), [t, categories, vehicleClasses]);

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} count_limit={count_limit} count_method={count_method} getFilter={getFilter} actions={topActions} />

      <TableExt
        getFilter={getFilter}
        theme={theme}
        title={t('sections.Тарифы')}
        rows={{ count, items }}
        className={className}
        refresh={props.refresh}
        clientId={clientId}
        onRowClick={rightView ? onRowClick : undefined}
        {...tableParams}
      />
    </GridBox>
  );
};
